































import { defineComponent } from '@vue/composition-api';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDeliveryNoteStatus from '@/useDeliveryNote';
import useDelivery from '@/useDelivery';

const SystemDisplay = defineComponent({
  setup() {
    const { distanceTypeToChipClass, translateDistanceType } = useDeliveryAreaCode();
    const { shipmentStatusClassMap, translate: deliveryTranslate } = useDelivery();
    const { deliveryNoteStatusClassMap, translate: deliveryNoteTranslate } = useDeliveryNoteStatus();

    return {
      distanceTypeToChipClass,
      translateDistanceType,

      shipmentStatusClassMap,
      deliveryTranslate,

      deliveryNoteStatusClassMap,
      deliveryNoteTranslate,
    };
  },
});

export default SystemDisplay;
